export default __webpack_public_path__ + "static/media/loss-label-icon.959e1271.svg";